var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "photo-viewer-panel" },
    [
      _c("ui-button", {
        staticClass: "close-button",
        attrs: { icon: "magicon-close" },
        on: { click: _vm.close },
      }),
      _c("div", { ref: "imageContainer", staticClass: "image-container" }, [
        _c("div", {
          ref: "image",
          staticClass: "image",
          style: { backgroundImage: `url(${_vm.image.url})` },
        }),
      ]),
      _c("table", [
        _c("tr", [
          _c("td", { staticClass: "key" }, [_vm._v("Actie")]),
          _c("td", { staticClass: "value" }, [
            _vm._v(
              _vm._s(
                _vm._f("actionTypeTitle")(_vm.action.__typename, _vm.action)
              )
            ),
          ]),
        ]),
        _c("tr", [
          _c("td", { staticClass: "key" }, [_vm._v("Datum")]),
          _c("td", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("date")(_vm.action.date, "DD MMMM YYYY"))),
          ]),
        ]),
        _c("tr", [
          _c("td", { staticClass: "key" }, [_vm._v("Perceel")]),
          _c("td", { staticClass: "value" }, [
            _vm._v(
              _vm._s(_vm.section.parcel.parcelLocation.name) +
                " " +
                _vm._s(_vm.section.parcel.parcelLocation.number) +
                " - " +
                _vm._s(_vm.section.parcel.alias)
            ),
          ]),
        ]),
        _c("tr", [
          _c("td", { staticClass: "key" }, [_vm._v("Vak")]),
          _c("td", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.section.name)),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }